<template>
  <div>
    <v-list>
      <v-list-tile
        v-for="(attachment, i) in attachments" :key="i">
        <v-list-tile-content>
          <v-list-tile-title>
            {{ attachment.filename }}
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon @click.native.stop="remove(i)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    <input v-else type="file" @change="handleFileChange">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Upload from '@/api/upload'
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    directory: {
      type: String,
      required: true
    }
  },
  computed: mapGetters({
    platform: 'skiliko/session/currentPlatform'
  }),
  data () {
    return {
      loading: false,
      attachments: [...this.value]
        .filter(x => x)
    }
  },
  watch: {
    attachments () {
      this.$emit('input', [...this.attachments])
    }
  },
  methods: {
    remove (i) {
      const newArray = [...this.attachments]
      newArray.splice(i, 1)
      this.attachments = newArray
    },
    handleFileChange (event) {
      const file = event.currentTarget.files[0]
      this.loading = true
      Upload.send({
        file,
        platform: this.platform,
        path: this.directory
      })
        .then(({ data }) => {
          this.attachments = [
            ...this.attachments,
            {
              url: data.url,
              filename: file.name
            }
          ]
          this.loading = false
        })
        .catch(_ => (this.loading = false))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/Attachment.vue